import InputMask, { ReactInputMask } from 'react-input-mask';

function DocumentCPFMask(props: Readonly<ReactInputMask>) {
  return <InputMask mask="999.999.999-99" {...props} />;
}

export default DocumentCPFMask;
